export default {
    'this-double-visit-report': 'this Double visit report',
    'add-new-report': 'Add new report'
}